import React, { useEffect, useState } from 'react'
import './App.css'
import './AccountDeletion.css'
import { Redirect } from 'react-router-dom'
import axios from 'axios'
import Header from './components/Header'
import { API_URL } from './config'

const ENDPOINT = `${API_URL}/apps/kscanner/webservices.php`

const STEPS = [
  ['Enter your details', 'Email, password and the reason for leaving.'],
  ['Check your inbox', 'We send a confirmation code to your email.'],
  ['Complete the request', 'Enter the code to finish.'],
]

const Eyebrow = ({ children }) => (
  <span className="kx-ad-pill">
    <i /> {children}
  </span>
)

const AccountDeletion = () => {
  const [step, setStep] = useState(1)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [reason, setReason] = useState('')
  const [code, setCode] = useState('')
  const [disabled, setDisabled] = useState(false)
  const [alert, setAlert] = useState(null) // { type: 'error' | 'success', text }

  useEffect(() => {
    document.title = 'Account Deletion - Karamale'
  }, [])

  if (localStorage.getItem('customername') !== null) {
    return <Redirect to="/customerdashboard" />
  }

  const failMessage = 'Something went wrong, please try again.'

  const submitRequest = (event) => {
    event.preventDefault()
    setDisabled(true)
    setAlert(null)

    const formData = new FormData()
    formData.append('email', email)
    formData.append('reason', reason)
    formData.append('password', password)
    formData.append('query', 'REQUEST_ACCOUNT_DELETION')

    axios({
      url: ENDPOINT,
      method: 'POST',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((response) => {
        if (response.data.code == 401) {
          setAlert({ type: 'error', text: response.data.message })
          setDisabled(false)
        } else {
          setStep(2)
          setDisabled(false)
        }
      })
      .catch((error) => {
        console.log(error)
        setAlert({ type: 'error', text: failMessage })
        setDisabled(false)
      })
  }

  const submitCode = (event) => {
    event.preventDefault()
    setDisabled(true)
    setAlert(null)

    const formData = new FormData()
    formData.append('code', code)
    formData.append('email', email)
    formData.append('query', 'REQUEST_ACCOUNT_DELETION')
    formData.append('subQuery', 'CONFIRM_CODE')

    axios({
      url: ENDPOINT,
      method: 'POST',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((response) => {
        if (response.data.code == 401) {
          setAlert({ type: 'error', text: response.data.message })
          setDisabled(false)
        } else {
          setAlert({ type: 'success', text: response.data.message })
        }
      })
      .catch((error) => {
        console.log(error)
        setAlert({ type: 'error', text: failMessage })
        setDisabled(false)
      })
  }

  const done = alert && alert.type === 'success'

  return (
    <div className="kx-ad-page">
      <Header />

      <section className="kx-ad-hero">
        <div className="kx-ad-aurora" aria-hidden="true">
          <span className="kx-ad-aurora__a" />
          <span className="kx-ad-aurora__b" />
        </div>
        <div className="kx-ad-wrap kx-ad-hero__inner">
          <div>
            <Eyebrow>Account deletion</Eyebrow>
            <h1>
              Request account
              <br />
              <em>deletion.</em>
            </h1>
            <p className="kx-ad-hero__sub">
              Tell us who you are, confirm with the code we email you, and your request is done.
            </p>
          </div>

          <ol className="kx-ad-steps">
            {STEPS.map(([title, text], i) => (
              <li key={title} className={step === 2 && i === 0 ? 'is-done' : ''}>
                <span className="kx-ad-steps__n">{i + 1}</span>
                <div>
                  <strong>{title}</strong>
                  <p>{text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="kx-ad-section">
        <div className="kx-ad-wrap">
          <div className="kx-ad-card">
            <div className="kx-ad-card__head">
              <span>{step === 1 ? 'Step 1 of 2' : 'Step 2 of 2'}</span>
              <b>
                <i /> {step === 1 ? 'Your details' : 'Confirmation'}
              </b>
            </div>

            {step === 1 && (
              <form onSubmit={submitRequest} className="kx-ad-form">
                <div className="kx-ad-field">
                  <label htmlFor="email">Email address</label>
                  <input
                    type="email"
                    id="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="kx-ad-field">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    id="password"
                    placeholder="Your account password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="kx-ad-field">
                  <label htmlFor="reason">Reason</label>
                  <textarea
                    id="reason"
                    rows={4}
                    placeholder="State your reason"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    required
                  />
                </div>

                {alert && alert.type === 'error' && (
                  <div className="kx-ad-alert kx-ad-alert--error" role="alert">
                    {alert.text}
                  </div>
                )}

                <button type="submit" className="kx-ad-btn kx-ad-btn--brand" disabled={disabled}>
                  {disabled ? 'Submitting…' : 'Submit request'}
                </button>
              </form>
            )}

            {step === 2 && !done && (
              <form onSubmit={submitCode} className="kx-ad-form">
                <div className="kx-ad-field">
                  <label htmlFor="code">Enter code</label>
                  <small>Code sent to {email}</small>
                  <input
                    type="text"
                    id="code"
                    className="kx-ad-input--code"
                    placeholder="Confirmation code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    autoComplete="one-time-code"
                    required
                  />
                </div>

                {alert && alert.type === 'error' && (
                  <div className="kx-ad-alert kx-ad-alert--error" role="alert">
                    {alert.text}
                  </div>
                )}

                <button type="submit" className="kx-ad-btn kx-ad-btn--brand" disabled={disabled}>
                  {disabled ? 'Confirming…' : 'Complete request'}
                </button>
              </form>
            )}

            {done && (
              <div className="kx-ad-done" role="status">
                <span className="kx-ad-tick" aria-hidden="true" />
                <div>
                  <strong>Request complete.</strong>
                  <p>{alert.text}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  )
}

export default AccountDeletion
